import { computed, observable } from 'mobx'

let nextId = 0

/**
 * A single per-state signed amount within a tax year block.
 */
export class StateAmountEntryViewModel {
  readonly id = ++nextId
  @observable accessor state = ''
  @observable accessor amount = 0

  constructor(state = '', amount = 0) {
    this.state = state
    this.amount = amount
  }

  /**
   * Whether a state is selected.
   */
  @computed
  get isCompleted() {
    return this.state !== ''
  }
}
